import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from "@material-ui/core/styles";
import MaterialTable from "material-table";
import {SizeMe} from "react-sizeme";
import tableIcons from "../constants/tableIcons";

const useStyles = makeStyles(theme => ({
    dialog: {
        '& .MuiDialog-paper': {
            width: 600,
        },
    },
}));

const ChooseExportFields = props => {
    const classes = useStyles();
    const tableRef = React.createRef();

    let accountFields = [
        {
            id: 'accountId',
            title: 'Account Id',
        },
        {
            id: 'accountName',
            title: 'Account Name',
        },
        {
            id: 'accountDescription',
            title: 'Description',
        },
        {
            id: 'accountLinkedinId',
            title: 'Linkedin Id',
        },
        {
            id: 'tags',
            title: 'Tag List',
        },
        {
            id: 'primaryEmailAddress',
            title: 'Primary Email Address',
        },
        {
            id: 'otherEmailAddresses',
            title: 'Other Email Addresses',
        },
        {
            id: 'primaryMailAddress',
            title: 'Primary Mail Address',
        },
        {
            id: 'otherMailAddresses',
            title: 'Other Mail Addresses',
        },
        {
            id: 'primaryPhoneNumber',
            title: 'Primary Phone Number',
        },
        {
            id: 'otherPhoneNumbers',
            title: 'Other Phone Numbers',
        },
        {
            id: 'createdAt',
            title: 'Creation Date',
        },
        {
            id: 'updatedAt',
            title: 'Last Updated Date'
        },
    ]

    let contactFields = [
        {
            id: 'contactId',
            title: 'Contact Id',
        },
        {
            id: 'displayName',
            title: 'Name - Full',
        },
        {
            id: 'contactLastFirstName',
            title: 'Name - Last, First',
        },
        {
            id: 'contactSalutation',
            title: 'Salutation',
        },
        {
            id: 'contactFirstName',
            title: 'First Name',
        },
        {
            id: 'contactMiddleName',
            title: 'Middle Name',
        },
        {
            id: 'contactLastName',
            title: 'Last Name',
        },
        {
            id: 'contactSuffix',
            title: 'Suffix',
        },
        {
            id: 'contactNickName',
            title: 'Nick Name',
        },
        {
            id: 'contactDescription',
            title: 'Description',
        },
        {
            id: 'contactLinkedinId',
            title: 'Linkedin Id',
        },
        {
            id: 'tags',
            title: 'Tag List',
        },
        {
            id: 'primaryEmailAddress',
            title: 'Primary Email Address',
        },
        {
            id: 'otherEmailAddresses',
            title: 'Other Email Addresses',
        },
        {
            id: 'primaryMailAddress',
            title: 'Primary Mail Address',
        },
        {
            id: 'otherMailAddresses',
            title: 'Other Mail Addresses',
        },
        {
            id: 'primaryPhoneNumber',
            title: 'Primary Phone Number',
        },
        {
            id: 'otherPhoneNumbers',
            title: 'Other Phone Numbers',
        },
        {
            id: 'currentAccounts',
            title: 'Current Accounts',
        },
        {
            id: 'createdAt',
            title: 'Creation Date',
        },
        {
            id: 'updatedAt',
            title: 'Last Updated Date'
        },
    ]

    const columns = [
        {title: 'Field Name', field: 'title'},
    ]

    // dont delete this yet.  trying to get gql query
    // const getFieldNames = (rows) => {
    //     let str = '{\n';
    //     for (let r = 0; r < rows.length; r++) {
    //         const row = rows[r]
    //         if (row.tableData.childRows && row.tableData.childRows.length > 0) {
    //             let childStr = '';
    //             for (let c = 0; c < row.tableData.childRows.length; c++) {
    //                 const childRow = row.tableData.childRows[c];
    //                 if (childRow.tableData.checked) childStr += '\t\t' + childRow.id + '\n';
    //             }
    //             if (childStr.length > 0) str += '\t' + row.id + ' {\n' + childStr + '\t}\n';
    //         } else if (row.tableData.checked) {
    //             str += '\t' + row.id + '\n';
    //         }
    //     }
    //     str += '}\n';
    //     return str
    // };

    const getFieldNames = (rows) => {
        let fields = {};
        for (let r = 0; r < rows.length; r++) {
            const row = rows[r]
            if (row.tableData.checked) {
                fields[row.id] = true;
            }
        }
        return fields
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleNo}
            className={classes.dialog}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <SizeMe>
                    {({size}) => {
                        let height = size.height;
                        if (!height) height = window.innerHeight;

                        const tableOptions = {
                            actionsColumnIndex: -1,
                            header: true,
                            maxBodyHeight: height - 200,
                            padding: 'dense',
                            paging: false,
                            selection: true,
                            toolbar: false,
                        };

                        return (<MaterialTable
                            tableRef={tableRef}
                            title="Choose Export Fields"
                            data={props.filterType === 'account' ? accountFields : contactFields}
                            columns={columns}
                            icons={tableIcons}
                            options={tableOptions}
                            // parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                            // onSelectionChange={(rows) => {
                            //     setSelectedRows(rows);
                            // }}
                            // onSelectionChange={handleSelectionChange}
                        />)
                    }}
                </SizeMe>
            </DialogContent>
            <DialogActions>
                <Button
                    id={"confirmation-cancel"}
                    variant="contained"
                    onClick={() => {
                        props.handleCancel();
                    }}
                    color="secondary"
                >
                    Cancel
                </Button>
                <Button
                    id={"confirmation-export"}
                    variant="contained"
                    onClick={() => {
                        const selectedFields = getFieldNames(tableRef.current.state.data, null)
                        // const queryStr = `query ContactsExport($contactIds: [ID!]!) { contactsExport(contactIds: $contactIds) ${selectedFields} }`;
                        // const query = gql(queryStr);
                        props.handleExport(selectedFields);
                    }}
                    color="primary"
                    autoFocus
                >
                    Export
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChooseExportFields
